// Get all trades
export const GET_CHILD_PARAGRAPHS_BASED_ON_BUILDING_REQUEST = "GET_CHILD_PARAGRAPHS_BASED_ON_BUILDING_REQUEST";
export const GET_CHILD_PARAGRAPHS_BASED_ON_BUILDING_SUCCESS = "GET_CHILD_PARAGRAPHS_BASED_ON_BUILDING_SUCCESS";
export const GET_CHILD_PARAGRAPHS_BASED_ON_BUILDING_FAILURE = "GET_CHILD_PARAGRAPHS_BASED_ON_BUILDING_FAILURE";

// Add trade
export const ADD_CHILD_PARAGRAPH_REQUEST = "ADD_CHILD_PARAGRAPH_REQUEST";
export const ADD_CHILD_PARAGRAPH_SUCCESS = "ADD_CHILD_PARAGRAPH_SUCCESS";
export const ADD_CHILD_PARAGRAPH_FAILURE = "ADD_CHILD_PARAGRAPH_FAILURE";

// Update trade
export const UPDATE_CHILD_PARAGRAPH_REQUEST = "UPDATE_CHILD_PARAGRAPH_REQUEST";
export const UPDATE_CHILD_PARAGRAPH_SUCCESS = "UPDATE_CHILD_PARAGRAPH_SUCCESS";
export const UPDATE_CHILD_PARAGRAPH_FAILURE = "UPDATE_CHILD_PARAGRAPH_FAILURE";

// Delete trade
export const DELETE_CHILD_PARAGRAPH_REQUEST = "DELETE_CHILD_PARAGRAPH_REQUEST";
export const DELETE_CHILD_PARAGRAPH_SUCCESS = "DELETE_CHILD_PARAGRAPH_SUCCESS";
export const DELETE_CHILD_PARAGRAPH_FAILURE = "DELETE_CHILD_PARAGRAPH_FAILURE";

// Get Trade by Id
export const GET_CHILD_PARAGRAPH_BY_ID_REQUEST = "GET_CHILD_PARAGRAPH_BY_ID_REQUEST";
export const GET_CHILD_PARAGRAPH_BY_ID_SUCCESS = "GET_CHILD_PARAGRAPH_BY_ID_SUCCESS";
export const GET_CHILD_PARAGRAPH_BY_ID_FAILURE = "GET_CHILD_PARAGRAPH_BY_ID_FAILURE";

// Update Trade Entity Param
export const UPDATE_CHILD_PARAGRAPH_ENTITY_PARAMS_SUCCESS = "UPDATE_CHILD_PARAGRAPH_ENTITY_PARAMS_SUCCESS";
export const UPDATE_CHILD_PARAGRAPH_ENTITY_PARAMS_FAILURE = "UPDATE_CHILD_PARAGRAPH_ENTITY_PARAMS_FAILURE";

export const GET_LIST_FOR_COMMON_FILTER_REQUEST = "GET_LIST_FOR_COMMON_FILTER_REQUEST";
export const GET_LIST_FOR_COMMON_FILTER_SUCCESS = "GET_LIST_FOR_COMMON_FILTER_SUCCESS";
export const GET_LIST_FOR_COMMON_FILTER_FAILURE = "GET_LIST_FOR_COMMON_FILTER_FAILURE";

export const GET_ALL_CHILD_PARAGRAPH_LOG_REQUEST = "GET_ALL_CHILD_PARAGRAPH_LOG_REQUEST";
export const GET_ALL_CHILD_PARAGRAPH_LOG_SUCCESS = "GET_ALL_CHILD_PARAGRAPH_LOG_SUCCESS";
export const GET_ALL_CHILD_PARAGRAPH_LOG_FAILURE = "GET_ALL_CHILD_PARAGRAPH_LOG_FAILURE";

export const RESTORE_CHILD_PARAGRAPH_LOG_REQUEST = "RESTORE_CHILD_PARAGRAPH_LOG_REQUEST";
export const RESTORE_CHILD_PARAGRAPH_LOG_SUCCESS = "RESTORE_CHILD_PARAGRAPH_LOG_SUCCESS";
export const RESTORE_CHILD_PARAGRAPH_LOG_FAILURE = "RESTORE_CHILD_PARAGRAPH_LOG_FAILURE";

export const DELETE_CHILD_PARAGRAPH_LOG_REQUEST = "DELETE_CHILD_PARAGRAPH_LOG_REQUEST";
export const DELETE_CHILD_PARAGRAPH_LOG_SUCCESS = "DELETE_CHILD_PARAGRAPH_LOG_SUCCESS";
export const DELETE_CHILD_PARAGRAPH_LOG_FAILURE = "DELETE_CHILD_PARAGRAPH_LOG_FAILURE";

export const GET_CHILD_PARAGRAPH_EXPORT_REQUEST = "GET_CHILD_PARAGRAPH_EXPORT_REQUEST";
export const GET_CHILD_PARAGRAPH_EXPORT_SUCCESS = "GET_CHILD_PARAGRAPH_EXPORT_SUCCESS";
export const GET_CHILD_PARAGRAPH_EXPORT_FAILURE = "GET_CHILD_PARAGRAPH_EXPORT_FAILURE";

export const GET_ALL_CLIENT_USERS_REQUEST = "GET_ALL_CLIENT_USERS_REQUEST";
export const GET_ALL_CLIENT_USERS_SUCCESS = "GET_ALL_CLIENT_USERS_SUCCESS";
export const GET_ALL_CLIENT_USERS_FAILURE = "GET_ALL_CLIENT_USERS_FAILURE";

// Get all consultancy users
export const GET_ALL_CONSULTANCY_USERS_REQUEST = "GET_ALL_CONSULTANCY_USERS_REQUEST";
export const GET_ALL_CONSULTANCY_USERS_SUCCESS = "GET_ALL_CONSULTANCY_USERS_SUCCESS";
export const GET_ALL_CONSULTANCY_USERS_FAILURE = "GET_ALL_CONSULTANCY_USERS_FAILURE";

export const GET_ALL_CONSULTANCIES_DROPDOWN_REQUEST = "GET_ALL_CONSULTANCIES_DROPDOWN_REQUEST";
export const GET_ALL_CONSULTANCIES_DROPDOWN_SUCCESS = "GET_ALL_CONSULTANCIES_DROPDOWN_SUCCESS";
export const GET_ALL_CONSULTANCIES_DROPDOWN_FAILURE = "GET_ALL_CONSULTANCIES_DROPDOWN_FAILURE";

// Get all Clients
export const GET_ALL_CLIENTS_REQUEST = "GET_ALL_CLIENTS_REQUEST";
export const GET_ALL_CLIENTS_SUCCESS = "GET_ALL_CLIENTS_SUCCESS";
export const GET_ALL_CLIENTS_FAILURE = "GET_ALL_CLIENTS_FAILURE";

export const GET_ALL_BUILDINGS_DROP_DOWN_REQUEST = "GET_ALL_BUILDINGS_DROP_DOWN_REQUEST";
export const GET_ALL_BUILDINGS_DROP_DOWN_SUCCESS = "GET_ALL_BUILDINGS_DROP_DOWN_SUCCESS";
export const GET_ALL_BUILDINGS_DROP_DOWN_FAILURE = "GET_ALL_BUILDINGS_DROP_DOWN_FAILURE";

export const GET_ASSIGN_MODAL_DETAILS_REQUEST = "GET_ASSIGN_MODAL_DETAILS_REQUEST";
export const GET_ASSIGN_MODAL_DETAILS_SUCCESS = "GET_ASSIGN_MODAL_DETAILS_SUCCESS";
export const GET_ASSIGN_MODAL_DETAILS_FAILURE = "GET_ASSIGN_MODAL_DETAILS_FAILURE";

export const ASSIGN_ITEMS_REQUEST = "ASSIGN_ITEMS_REQUEST";
export const ASSIGN_ITEMS_SUCCESS = "ASSIGN_ITEMS_SUCCESS";
export const ASSIGN_ITEMS_FAILURE = "ASSIGN_ITEMS_FAILURE";

export const GET_SPECIAL_REPORTS_DROPDOWN_REQUEST = "GET_SPECIAL_REPORTS_DROPDOWN_REQUEST";
export const GET_SPECIAL_REPORTS_DROPDOWN_SUCCESS = "GET_SPECIAL_REPORTS_DROPDOWN_SUCCESS";
export const GET_SPECIAL_REPORTS_DROPDOWN_FAILURE = "GET_SPECIAL_REPORTS_DROPDOWN_FAILURE";

export const GET_REPORT_PARAGRAPHS_DROPDOWN_REQUEST = "GET_REPORT_PARAGRAPHS_DROPDOWN_REQUEST";
export const GET_REPORT_PARAGRAPHS_DROPDOWN_SUCCESS = "GET_REPORT_PARAGRAPHS_DROPDOWN_SUCCESS";
export const GET_REPORT_PARAGRAPHS_DROPDOWN_FAILURE = "GET_REPORT_PARAGRAPHS_DROPDOWN_FAILURE";
